import BookingFormLayout, { transformValues } from './form'
import GenericEditForm from '../common/edit'

export default () => <GenericEditForm formLayoutComponent={<BookingFormLayout />} transformValues={transformValues} />
